import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from "@air/primitive-popover";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useAirModal } from "@air/provider-modal";
import { memo, useCallback, useState } from "react";
import { FilterButton } from "~/components/Filters/SingleFilters/FilterButton";
import { DropdownMenuActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
export const FilterTrigger = /*#__PURE__*/ memo((param)=>{
    let { count, title, onRemoveClick, filterContent, Icon, values, onOpenChange: _onOpenChange } = param;
    const [showActionSheet] = useAirModal(DropdownMenuActionSheet);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const [isExpanded, setIsExpanded] = useState(false);
    const onOpenChange = useCallback((open)=>{
        setIsExpanded(open);
        _onOpenChange === null || _onOpenChange === void 0 ? void 0 : _onOpenChange(open);
    }, [
        _onOpenChange
    ]);
    if (isAboveMediumScreen) {
        return /*#__PURE__*/ _jsx(Popover, {
            className: "w-auto p-3 md:w-80",
            onOpenChange: onOpenChange,
            trigger: /*#__PURE__*/ _jsx(FilterButton, {
                count: count,
                Icon: Icon,
                isOpen: isExpanded,
                onRemoveClick: onRemoveClick,
                title: title,
                values: values
            }),
            children: filterContent
        });
    }
    /**
     * @TODO - Remove this during `searchImprovements` cleanup since it will never be visible on mobile.
     */ return /*#__PURE__*/ _jsx(FilterButton, {
        count: count,
        Icon: Icon,
        isOpen: isExpanded,
        onRemoveClick: onRemoveClick,
        onClick: (event)=>{
            event.stopPropagation();
            showActionSheet({
                content: filterContent,
                onChange: setIsExpanded,
                title
            });
        },
        title: title,
        values: values
    });
});
FilterTrigger.displayName = "FilterTrigger";
